const theme = {
  colors: {
    primary: 'green',
    primaryLight: 'white',
    stars: 'green',
    starsEmission: 'green',
    light: 'cyan',
    dark: 'black',
    contrast: 'green',
    cubeEmissionEdgeColor: { r: 0, g: 1, b: 1 }, // values should be from 0-1
    cubeEdgeColor: { r: 0, g: 1, b: 1 }, // values should be from 0-1
    cubeEmissionFaceColor: { r: 0, g: 0.05, b: 0.05 }, // values should be from 0-1
    cubeFaceColor: { r: 0, g: 0, b: 0 },
  },
};

export default theme;
